import React from 'react';
import {connect} from 'react-redux';
import {AppState} from '@Redux/store';
import { FormattedMessage } from 'react-intl';

interface IUnitTypeViewProps {
  height: string
  base: string
  type: string
}

const UnitTypeView: React.FC<UnitTypeViewProps> = ({ height, type, base }) => {
  return (
    <ul className={'list-inline mb-1 text-center'}>
      <li className={'list-inline-item'}><span className="text-italic">Size:</span> <FormattedMessage id={height} /></li>
      <li className={'list-inline-item'}><span className="text-italic">Type:</span> {type}</li>
      <li className={'list-inline-item'}><span className="text-italic">Base:</span> <FormattedMessage id={base} /></li>
    </ul>
  );
};

const mapStateToProps = (state: AppState, owsProps: IUnitTypeViewProps) => ({
  height: owsProps.height,
  type: owsProps.type,
  base: owsProps.base
});

const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(UnitTypeView);

type UnitTypeViewProps = ReturnType<typeof mapDispatchToProps> &
                          ReturnType<typeof mapStateToProps>
